<template>
  <div class="dashboard-editor-container">
    <div class="dashboard-editor-containera">
      <el-container class="el-containers">
        <el-main>
          <div class="imagesbox">
            <el-carousel style="width: 100%; height: 100%">
              <el-carousel-item v-for="item in imagesbox" :key="item.id" style="height: 100%">
                <img :src="api.concat(item.img)" class="image" style="width: 100%; height: 100%"
                  @click="toDetail(item)" />
              </el-carousel-item>
            </el-carousel>
          </div>
        </el-main>
      </el-container>
    </div>

    <!-- 精选文章 精选主题 -->
    <div class="center">
      <el-container>
        <el-main>
          <div class="list">
            <div class="grid-content">最新学术资源</div>
            <V-ArticleList :newarticlelist="newarticlelist"></V-ArticleList>
            
          </div>
        </el-main>
      </el-container>
    </div>
    <div class="pages">
      <el-pagination background :page-size="limit" :current-page="page" layout="prev, pager, next"
        @current-change="pageUpdate" :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import ArticleList from "@/components/one-article/type-one/index.vue";

import api from '@/services/config.js'
import { getSlideshow, getArctilce } from '@/services/'

import {
  showTimeFormat,
  formatDate,
  dataFormat,
  updateHotnumFn,
  integralAddOne,
} from "@/js/common";

export default {
  name: "Home",
  components: { "V-ArticleList": ArticleList },
  data() {
    return {
      userInfo: {},
      limit: 5,
      page: 1,
      total: 0,
      newarticlelist: [],  //文章列表
      api,
      //轮播图
      imagesbox: [
        {
          idView: require("@/assets/u=1367050145,1852793189&fm=26&gp=0.jpg"),
        },
        {
          idView: require("@/assets/u=1367050145,1852793189&fm=26&gp=0.jpg"),
        },
        {
          idView: require("@/assets/u=1367050145,1852793189&fm=26&gp=0.jpg"),
        },
        {
          idView: require("@/assets/u=1367050145,1852793189&fm=26&gp=0.jpg"),
        },
        {
          idView: require("@/assets/u=1367050145,1852793189&fm=26&gp=0.jpg"),
        },
        {
          idView: require("@/assets/u=1367050145,1852793189&fm=26&gp=0.jpg"),
        },
        {
          idView: require("@/assets/u=1367050145,1852793189&fm=26&gp=0.jpg"),
        },
      ],
    };
  },
  created() {
    let ui = sessionStorage.getItem('userInfo');
    try {
      if (ui) {
        this.userInfo = JSON.parse(ui);
      }
    } catch (error) {

    }
    this.initCarousel(); //初始化轮播图
    this.searchInfo(); //初始化文章列表
  },
  methods: {
    // 初始化轮播图
    initCarousel() {
      getSlideshow({ type: 1 }).then(res => {
        if (res.success) {
          let list = res.data.records
          if (list && list.length > 0) {
            this.imagesbox = list;
          }
        } else {
          this.$message({
            message: res.message,
            type: "warning"
          });
        }
      })
    },

    // 初始化文章列表
    searchInfo() {
      getArctilce({ type: 1, pageIndex:this.page, pageSize:  this.limit }).then(res => {
        if (res.success) {
          let list = res.data.records
          this.total = res.data.total || 0
          if (list && list.length > 0) {
            this.newarticlelist = list;
          }
        } else {
          this.message({
            message: res.message,
            type: 'warning'
          })
        }
      })
    },

    //更改分页
    pageUpdate(e) {
      this.newarticlelist = [];
      this.page = e;
      console.log(e);
      this.searchInfo();
    },

    toDetail(item){
      if(item&&item.arcticle)
      this.$router.push('/articleDetail?id=' + item.arcticle)
    }
  }
};
</script>
<style scoped>
.dashboard-editor-container {
  width: 100%;
  position: relative;
  /* border: 1px solid red; */
}

.dashboard-editor-containera {
  width: 100%;
  height: 330px;
  padding-top: 20px;
  padding-bottom: 20px;
  background-color: #ffffff;
  /* border: 1px solid darkblue; */
  display: inline-block;
}

.list {
  margin-bottom: 20px;
}

.center {
  width: 85%;
  margin: auto;
  margin-top: 40px;
}

.el-main {
  padding: 0;
}

.el-carousel__item img {
  width: 100%;
}

.plcont {
  cursor: pointer;
}

.el-timeline {
  margin-top: 4%;
}

.ad {
  margin-top: 8px;
  width: 6px;
  height: 6px;
  background: rgba(115, 139, 179, 1);
  border: 1px solid rgba(115, 139, 179, 1);
  border-radius: 50%;
  float: left;
}

.el-aside span {
  margin-left: 5px;
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(110, 113, 129, 1);
  line-height: 22px;
}

.radio_left {
  float: left;
  margin-top: 15px;

  background-color: #1e68bc;
  border-radius: 0px 11px 11px 0px;
  background-size: 100% 100%;
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 14px;
  padding: 5px 11px 5px 0px;
}

/*最新快讯刷新图标点击动画效果*/
.flash-bin {
  transition: 0.5s;
  transform: rotate(360deg);
  display: inline-block;
}

/*精选文章超出隐藏*/
#jinxuan1 {
  font-size: 17px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
  line-height: 40px;
}

#jinxuan2 {
  float: right;
  font-family: Microsoft YaHei;
  font-weight: 400;
  font-size: 13px;
  color: rgba(120, 120, 120, 1);
  line-height: 40px;
}

.el-aside .aside_t p {
  overflow: hidden;
  height: 21px;
  text-overflow: ellipsis;
  cursor: pointer;
}

.aside_t_b li {
  line-height: 28px;
  overflow: hidden;
  height: 22px;
  text-overflow: ellipsis;
  cursor: pointer;
  margin-top: 10px;
}

.aside_t_t .el-image {
  cursor: pointer;
}

.containersss {
  width: 100%;
  /* border: 1px solid forestgreen; */
}

.purpleaa {
  width: 28%;
  height: 99%;
  /* height: 500px; */
  margin-left: 10px;
  /* border: 1px solid firebrick; */
  display: inline-block;
  vertical-align: top;
}

.purpleaa img {
  width: 100%;
  height: 49%;
}

.imagesbox {
  width: 100%;
  display: inline-block;
  height: 99%;
  /* border: 1px solid red; */
  /* background-color:#FFFFFF; */
  /* border: 1px solid fuchsia; */
}

.el-containers {
  width: 85%;
  margin: auto;
  height: 100%;
  /* display: inline-block; */
  /* background: #FFFFFF; */
  /* border: 1px solid red; */
}

.kuaixun {
  display: inline-block;
  vertical-align: top;
  /* height: 98%; */
  width: 99%;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(229, 229, 229, 1);
  box-shadow: 0px 4px 6px 0px rgba(88, 90, 92, 0.27);
}

.fllll {
  height: 360px;
  /* border: 1px solid firebrick; */
  display: inline-block;
}

.more:hover {
  color: rgb(6 6 7);
}

.xjwplcont div {
  width: 100%;
}

.xjwplcont div::after {
  display: block;
  content: "";
  clear: both;
}

.xjwplcont img {
  width: 92px;
  height: 66px;
  float: right;
}

.xjwplcont div .lines-ellipsis {
  width: 50%;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

/* .xjwplcont div .lines-ellipsis{
  width: 50%;
  height: 0.485295rem;
  overflow: hidden;
  position: relative;
} */
/* .xjwplcont div .lines-ellipsis::after{
  content:". . .";
  font-weight:bold;
  position:absolute;
  background: linear-gradient(to right,rgba(255,255,255,0.4), rgba(255,255,255,1),rgba(255,255,255,1),rgba(255,255,255,1),rgba(255,255,255,1));
  bottom:0;
  right:0;
  padding:0 0px 1px 25px;
} */
.grid-content {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
  line-height: 42px;
  border-bottom: 1px solid #b8b8b8;
  margin-left: 20px;
  margin-right: 20px;
}

.aside_b {
  position: relative;
  top: -9.2px;
  border-bottom: 1px solid #dcdcdc;
  border-left: 1px solid #dcdcdc;
  border-right: 1px solid #dcdcdc;
}

.aside_t {
  margin-bottom: 40px;
  border-bottom: 1px solid #dcdcdc;
  border-left: 1px solid #dcdcdc;
  border-right: 1px solid #dcdcdc;
}

.Jxwz {
  background: rgba(255, 255, 255, 1);
  border: 1px solid #dcdcdc;
}

.download {
  text-align: right;
  position: absolute;
  bottom: 190px;
  right: 0;
}

/* 下载二维码 */
.EWM {
  height: 102px;
  width: 102px;
  /* display: inline-block; */
  background-color: #c1c1c1;
}

.dis {
  /* float: left; */
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
}

.select-tips {
  position: absolute;
  width: 160px;
  height: 211px;
  right: 100%;
  top: 0;
  margin-left: 15px;
  background: #fff;
  min-width: 126px;
  border: 1px solid #ebeef5;
  padding: 12px;
  z-index: 2000;
  color: #606266;
  line-height: 1.4;
  text-align: justify;
  font-size: 14px;
  -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 2px 12px 0 rgba(185, 180, 180, 0.1);
  word-break: break-all;
  border: 3px solid #e5e5e5;
}

.select-tip-arrow {
  position: absolute;
  z-index: 2;
  top: 8%;
  right: -9px;
  width: 0;
  height: 0;
  border-top: 9px solid transparent;
  border-left: 9px solid #e5e5e5;
  border-bottom: 9px solid transparent;
}

.select-tip-arrow em {
  width: 0;
  height: 0;
  position: absolute;
  right: 3px;
  top: -6px;
  border-top: 6px solid transparent;
  border-left: 7px solid #fff;
  border-bottom: 6px solid transparent;
}

.fill-content .fill-d input {
  border-width: 0 0 1px 0;
  outline: none;
}

.shouji {
  display: inline-block;
  width: 13px;
  height: 15px;
  max-width: 13px;
  max-height: 15px;
  /* background-color: red; */
  background-image: url("~@/assets/手机.png");
  background-size: 13px 15px;
  vertical-align: bottom;
  margin-top: 10px;
  /* border:1px solid red; */
}

.select-btn {
  width: 35px;
  height: 40px;
  background: #0084ff;
  display: inline-block;
  font-size: 13px;
  font-family: Microsoft YaHei;
  font-weight: normal;
  color: #ffffff;
  margin-left: 10px;
  text-align: center;
  padding-top: 10px;
  padding-bottom: 10px;
}

.el-timeline>>>.el-timeline-item__timestamp {
  font-size: 12px;
}

.el-timeline>>>.el-timeline-item__content {
  font-size: 13px;
  line-height: 21px;
}

/* 超过两行换省略号 */
.sheng_luehao {
  overflow: hidden;
  text-overflow: ellipsis;
  display: flex;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

/* 快讯 */

.el-timeline-item__content {
  height: 35px;
  font-size: 13px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
  line-height: 21px;
}

::v-deep .el-timeline-item {
  padding-bottom: 20px;
}

.select-btn-grey {
  width: 35px;
  height: 40px;
  background: #979797;
  display: inline-block;
  font-size: 13px;
  font-family: Microsoft YaHei;
  font-weight: normal;
  color: #ffffff;
  margin-left: 10px;
  text-align: center;
  padding-top: 10px;
  padding-bottom: 10px;
  border-top: 2px solid #ffffff;
  cursor: pointer;
}

.pages {
  width: 100%;
  padding: 10px 0;
  padding-bottom: 30px;
  background-color: #fff;
}

.pages>.el-pagination {
  text-align: center;
}</style>
